import {
  GET_SIGNED_URL,
  GET_VEHICLE_VIDEO_LIST,
  SET_VIDEO_STREAM_STATUS,
  SET_VIDEO_STREAM_STATUS_OFF,
} from '@/services/api/trackvideo/video'
import { client } from '@/services/apolloclient'
import Vue from 'vue'
import store from '../store'
import { v4 as uuidv4 } from 'uuid'
import { Helper } from '@/mixin/helper'

export const state = {
  isWsConnected: false,
  fleets: [],
  tempVehicleStatuses: {},
  vehicleStatuses: {},
  loadingFleets: true,
  fleetSelection: [],
  fleetClose: {},
  fleetOpen: {},
  cameraProps: {},
  isVideoProps: {},
  isInVideoProps: {},
  isVideoFullscreenProps: {
    isLoading: false,
    isVideoError: false,
    isVideoStopped: false,
    isPlay: true,
    isMuted: false,
    isRequestOnlineCommand: false,
    onLoadingTimeout: null,
    retry: 0,
  },
  checkedVehicles: {},
  playlist: [],
  maxVideo: 16,
  gridNumber: 9,
  // This state only used in close from grid playlist, if playlist closed from checkbox, this state will be null
  lastClosedPlaylist: null,
  fleetListDisplay: {},
  workerTrackvision: null,
  recordIdActive: null, // Contain playlistId, recordActive must be 1 playlist
  mapFlespiHowenState: [],
  vehicleTypeList: [],
  vgroupsList: [],
}

export const getters = {
  fleetsListFilter: (state) => (search) => {
    if (!search) {
      return state.fleets || []
    }

    return state.fleets.filter(
      (fleet) =>
        fleet.vehicle.licensePlate.toLowerCase().match(search.toLowerCase()) ||
        (fleet.vehicle.driver1
          ? fleet.vehicle.driver1.fullname.toLowerCase().match(search.toLowerCase())
          : null)
    )
  },
  fleetsList: (state) => state.fleets || [],
  vehicleStatusByVehicleId: (state) => (vehicleId) => {
    return state.vehicleStatuses[vehicleId]
  },
  tempVehicleStatusByVehicleId: (state) => (vehicleId) => {
    return state.tempVehicleStatuses[vehicleId]
  },

  flespiHowenVehicleIds: (state) => {
    return state.fleets
      .filter(
        (fleet) => Helper.methods.getDeviceType(fleet.vehicle.device.deviceCode) === 'flespi-howen'
      )
      .map((fleet) => fleet.vehicleId)
  },
}

export const actions = {
  async requestFleets({ commit }, payload) {
    const dataDemoTrackvision = JSON.parse(
      store.state.identity.featureFlag.find(
        (feature) => feature.key == 'vsms2_trackvision2_stream_demo_id'
      ).value
    )
    await client
      .query({
        query: GET_VEHICLE_VIDEO_LIST,
        variables: payload,
        fetchPolicy: 'no-cache',
      })
      .then((response) => {
        if (response.data.vehicleVideoTrackers.isSuccessful) {
          var vehicles = response.data.vehicleVideoTrackers.vehicleVideoTrackers
          vehicles.forEach(function (item) {
            item.checked = false
            item.playlist = []
            item.channel = []
            item.vehicle.device.deviceType = Helper.methods.getDeviceType(
              item.vehicle.device.deviceCode
            )
            if (item.statusText) {
              item.statusText.split(',').forEach((row, index) => {
                item.channel.push({ text: index + 1, value: `${item.vehicleId}:${row}`, play: 0 })
              })
            }

            const trackvisionDemoId = JSON.parse(
              store.state.identity.featureFlag.find(
                (feature) => feature.key == 'vsms2_trackvision_demo_id'
              ).value
            )
            // Check video demo
            if (
              Object.keys(trackvisionDemoId)
                .map((id) => parseInt(id))
                .includes(item.vehicleId) ||
              (process.env.VUE_APP_ENV === 'production' &&
                Object.keys(dataDemoTrackvision)
                  .map((id) => parseInt(id))
                  .includes(item.vehicleId))
            ) {
              item.calculatedMotionStatus = 'M'
            }
          })

          commit('setFleets', vehicles)
        }
      })
  },

  async requestFleetsV2({ commit }, payload) {
    const dataDemoTrackvision = JSON.parse(
      store.state.identity.featureFlag.find(
        (feature) => feature.key == 'vsms2_trackvision2_stream_demo_id'
      ).value
    )
    await client
      .query({
        query: GET_VEHICLE_VIDEO_LIST,
        variables: payload,
        fetchPolicy: 'no-cache',
      })
      .then((response) => {
        if (response.data.vehicleVideoTrackers.isSuccessful) {
          var vehicles = response.data.vehicleVideoTrackers.vehicleVideoTrackers
          vehicles.forEach(function (item) {
            item.checked = false
            item.playlist = []
            item.channel = []
            // This variable model used for select options
            item.playlistModel = []
            item.vehicle.device.deviceType = Helper.methods.getDeviceType(
              item.vehicle.device.deviceCode
            )
            if (item.statusText) {
              item.channel.push({
                text: 'all',
                value: 'all',
              })
              item.statusText.split(',').forEach((row, index) => {
                item.channel.push({
                  text: index + 1,
                  value: `${item.vehicleId}:${row}`,
                  play: 0,
                })
              })
            }

            const trackvisionDemoId = JSON.parse(
              store.state.identity.featureFlag.find(
                (feature) => feature.key == 'vsms2_trackvision_demo_id'
              ).value
            )
            // Check video demo
            if (
              Object.keys(trackvisionDemoId)
                .map((id) => parseInt(id))
                .includes(item.vehicleId) ||
              (process.env.VUE_APP_ENV === 'production' &&
                Object.keys(dataDemoTrackvision)
                  .map((id) => parseInt(id))
                  .includes(item.vehicleId))
            ) {
              item.calculatedMotionStatus = 'M'
            }
          })

          commit('setFleets', vehicles)
        }
      })
  },

  async setVehicleTypeAndVgroups({ commit, state }) {
    const tempVehicleType = []
    const tempVgroups = []
    state.fleets.forEach((v) => {
      const _vehicleType = v.vehicle.vehicleType
      if (
        !tempVehicleType.some(({ vehicleTypeId }) => vehicleTypeId === _vehicleType.vehicleTypeId)
      ) {
        tempVehicleType.push(_vehicleType)
      }
      const _vgroups = v.vehicle.vehicle2Vgroup
      _vgroups.forEach((vg) => {
        if (!tempVgroups.some(({ vgroupId }) => vgroupId === vg.vgroupId)) {
          tempVgroups.push(vg)
        }
      })
    })

    commit('setVehicleTypeList', tempVehicleType)
    commit('setVgroupsList', tempVgroups)
  },

  // eslint-disable-next-line no-unused-vars
  async setVideoStreamStatus({ commit, dispatch }, payload) {
    const dataDemoTrackvision = JSON.parse(
      store.state.identity.featureFlag.find(
        (feature) => feature.key == 'vsms2_trackvision2_stream_demo_id'
      ).value
    )
    const isVideoDemo =
      process.env.VUE_APP_ENV === 'production' &&
      Object.keys(dataDemoTrackvision).includes(payload.vehicleId.toString())

    // handle video demo
    if (isVideoDemo) {
      const _channelSent = payload.playlist.map((data) =>
        payload.vehicle.device.deviceName.includes('JC')
          ? (parseInt(data.split(':')[1]) + 1).toString()
          : data.split(':')[1]
      )
      return { channelSent: _channelSent, channelNotSent: [] }
    }
    let promises = []

    const deviceType = Helper.methods.getDeviceType(payload.vehicle.device.deviceCode)

    const isJc = deviceType === 'jc'

    // Start stream
    const _channels = [] // '1', '2', '3'
    payload.playlist.forEach((row) => {
      const arr = row.split(':')
      _channels.push(isJc ? (parseInt(arr[1]) + 1).toString() : arr[1])
    })

    if (_channels.length) {
      promises.push(
        dispatch('requestOnlineCommandStreamStatus', {
          channels: _channels,
          imei: payload.vehicle.imei,
          status: true,
          streamingEndpoint: payload.streamingEndpoint,
          statsDataV2: {
            inputDataRequest: _channels.map((channel, index) => ({
              channel,
              id: payload.playlistWithUid[index].uid,
            })),
          },
        })
      )
    }

    return await Promise.all(promises).then((response) => {
      const channelSent =
        response[response.length - 1]?.data.setVideoStreamStatus.setVideoStreamStatus.channelSent
      const channelNotSent =
        response[response.length - 1]?.data.setVideoStreamStatus.setVideoStreamStatus.channelNotSent
      return { channelSent, channelNotSent }
    })
  },

  async setVideoStreamStatusV2({ commit, dispatch }, { dataVehicle, newChannel }) {
    const dataDemoTrackvision = JSON.parse(
      store.state.identity.featureFlag.find(
        (feature) => feature.key == 'vsms2_trackvision2_stream_demo_id'
      ).value
    )
    const isVideoDemo =
      process.env.VUE_APP_ENV === 'production' &&
      Object.keys(dataDemoTrackvision).includes(dataVehicle.vehicleId.toString())

    // handle video demo
    // TODO : Handle video demo
    if (isVideoDemo) {
      return {
        channelSent: newChannel.map((item) =>
          dataVehicle.vehicle.device.deviceName.includes('JC')
            ? (parseInt(item.split(':')[1]) + 1).toString()
            : item.split(':')[1]
        ),
        channelNotSent: [],
      }
    }
    let promises = []

    const deviceType = Helper.methods.getDeviceType(dataVehicle.vehicle.device.deviceCode)

    const isJc = deviceType === 'jc'

    // Start stream
    const _channelsWithUid = [] //{ channel: '1'|'2'|'3', uid: uuidv4() }
    newChannel.forEach((row) => {
      const arr = row.split(':')
      _channelsWithUid.push({
        channel: isJc ? (parseInt(arr[1]) + 1).toString() : arr[1],
        id: dataVehicle.playlistWithUid.find((item) => item.playlist === row).uid,
      })
    })

    if (_channelsWithUid.length) {
      promises.push(
        dispatch('requestOnlineCommandStreamStatus', {
          channels: _channelsWithUid.map((item) => item.channel),
          imei: dataVehicle.vehicle.imei,
          status: true,
          streamingEndpoint: dataVehicle.streamingEndpoint,
          statsDataV2: {
            inputDataRequest: _channelsWithUid,
          },
        })
      )
    }

    return await Promise.all(promises).then((response) => {
      const channelSent = response[0]?.data.setVideoStreamStatus.setVideoStreamStatus.channelSent
      const channelNotSent =
        response[0]?.data.setVideoStreamStatus.setVideoStreamStatus.channelNotSent
      return { channelSent, channelNotSent }
    })
  },

  async requestOnlineCommandStreamStatus(_, payload) {
    try {
      const response = await client.mutate({
        mutation: SET_VIDEO_STREAM_STATUS,
        variables: {
          input: {
            ...payload,
          },
        },
      })
      return response
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  },

  async setVideoStreamStatusOff() {
    await client.mutate({
      mutation: SET_VIDEO_STREAM_STATUS_OFF,
    })
  },
}

export const mutations = {
  ORDER_BY(state, payload) {
    if (payload.objName == 'licensePlate') {
      if (payload.order === 'asc') {
        state.fleets = state.fleets.sort((a, b) =>
          a.vehicle[payload.objName] > b.vehicle[payload.objName]
            ? 1
            : b.vehicle[payload.objName] > a.vehicle[payload.objName]
            ? -1
            : 0
        )
      } else {
        state.fleets = state.fleets.sort((a, b) =>
          b.vehicle[payload.objName] > a.vehicle[payload.objName]
            ? 1
            : a.vehicle[payload.objName] > b.vehicle[payload.objName]
            ? -1
            : 0
        )
      }
    } else {
      if (payload.order === 'asc') {
        state.fleets = state.fleets.sort((a, b) =>
          a[payload.objName] > b[payload.objName]
            ? 1
            : b[payload.objName] > a[payload.objName]
            ? -1
            : 0
        )
      } else {
        state.fleets = state.fleets.sort((a, b) =>
          b[payload.objName] > a[payload.objName]
            ? 1
            : a[payload.objName] > b[payload.objName]
            ? -1
            : 0
        )
      }
    }
  },
  setFleets(state, payload) {
    state.fleets = payload
  },
  setIsWsConnected(state, payload) {
    state.isWsConnected = payload
  },
  setVehicleStatuses(state, payload) {
    state.vehicleStatuses = payload
  },
  setTempVehicleStatusesByVehicleId(state, { vehicleId, data }) {
    state.tempVehicleStatuses[vehicleId] = data
  },
  setVehicleStatusesByVehicleId(state, { vehicleId, data }) {
    state.vehicleStatuses[vehicleId] = data
  },
  resetTempVehicleStatuses(state) {
    state.tempVehicleStatuses = {}
  },
  selectFleet(state, payload) {
    if (state.fleetSelection.includes(payload)) return

    if (state.fleetSelection.length >= 3) {
      Vue.set(state.isVideoProps, `video${payload.vehicleId}`, undefined)
      Vue.set(state.isInVideoProps, `video${payload.vehicleId}`, undefined)
      Vue.set(state.cameraProps, `video${payload.vehicleId}`, undefined)

      state.fleetClose = state.fleetSelection[0]
      state.fleetSelection.splice(0, 1)
    }

    const domainStart = ((state.fleetSelection.length * 2) % 3) + 1

    const arrDomain = (() => {
      if (domainStart === 1 || domainStart === 2) {
        return [domainStart, domainStart + 1]
      }
      if (domainStart === 3) {
        return [domainStart, 1]
      }
    })()

    const trackvisionDemoId = JSON.parse(
      store.state.identity.featureFlag.find((feature) => feature.key == 'vsms2_trackvision_demo_id')
        .value
    )
    const urlInside = Object.keys(trackvisionDemoId)
      .map((id) => parseInt(id))
      .includes(payload.vehicleId)
      ? trackvisionDemoId[payload.vehicleId].in
      : `${process.env.VUE_APP_RTMP_URL.replace('{numFlag}', arrDomain[1])}/live/1/${
          payload.vehicle.imei
        }.m3u8`
    const urlOutside = Object.keys(trackvisionDemoId)
      .map((id) => parseInt(id))
      .includes(payload.vehicleId)
      ? trackvisionDemoId[payload.vehicleId].out
      : `${process.env.VUE_APP_RTMP_URL.replace('{numFlag}', arrDomain[0])}/live/0/${
          payload.vehicle.imei
        }.m3u8`

    Vue.set(state.isVideoProps, `video${payload.vehicleId}`, {
      isLoading: false,
      isVideoError: false,
      isVideoStopped: false,
      isPlay: true,
      isMuted: false,
      onLoadingTimeout: null,
      src: urlOutside,
      retry: 0,
    })
    Vue.set(state.isInVideoProps, `video${payload.vehicleId}`, {
      isLoading: false,
      isVideoError: false,
      isVideoStopped: false,
      isPlay: true,
      isMuted: false,
      onLoadingTimeout: null,
      src: urlInside,

      retry: 0,
    })
    Vue.set(state.cameraProps, `video${payload.vehicleId}`, 'INOUT')

    payload.channel = payload.channel.map((channel) => ({
      ...channel,
      uid: uuidv4(),
    }))

    state.fleetOpen = payload
    state.fleetSelection.push(payload)
  },
  loadingFleets(state, payload) {
    state.loadingFleets = payload
  },
  removeFleet(state, payload) {
    state.fleetOpen = null

    if (state.checkedVehicles[payload.vehicleId]) {
      state.checkedVehicles[payload.vehicleId] = false
    }

    Vue.set(state.isVideoProps, `video${payload.vehicleId}`, undefined)
    Vue.set(state.isInVideoProps, `video${payload.vehicleId}`, undefined)
    Vue.set(state.cameraProps, `video${payload.vehicleId}`, undefined)

    const indexToRemove = state.fleetSelection.findIndex(
      (fleet) => fleet.vehicleId === payload.vehicleId
    )

    if (indexToRemove !== -1) {
      state.fleetSelection.splice(indexToRemove, 1)
    }
  },
  clearFleet(state) {
    state.fleetOpen = null

    Vue.set(state, `isVideoProps`, {})
    Vue.set(state, `isInVideoProps`, {})
    Vue.set(state, `cameraProps`, {})
    Vue.set(state, `fleetSelection`, [])
  },
  setVideoError(state, payload) {
    state.isVideoProps[`video${payload.vehicleId}`].isVideoError = payload.error
  },
  setInVideoError(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].isVideoError = payload.error
  },
  setVideoStopped(state, payload) {
    state.isVideoProps[`video${payload.vehicleId}`].isVideoStopped = payload.isStop
  },
  setInVideoStopped(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].isVideoStopped = payload.isStop
  },
  setPlay(state, payload) {
    state.isVideoProps[`video${payload.vehicleId}`].isPlay = payload.isPlay
  },
  setInPlay(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].isPlay = payload.isPlay
  },
  setMuted(state, payload) {
    state.isVideoProps[`video${payload.vehicleId}`].isMuted = payload.isMuted
  },
  setInMuted(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].isMuted = payload.isMuted
  },
  setRetry(state, payload) {
    state.isVideoProps[`video${payload.vehicleId}`].retry = payload.retry
  },
  setInRetry(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].retry = payload.retry
  },
  setLoading(state, payload) {
    state.isVideoProps[`video${payload.vehicleId}`].isLoading = payload.isLoading
  },
  setInLoading(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].isLoading = payload.isLoading
  },
  setRequestOnlineCommand(state, payload) {
    state.isVideoProps[`video${payload.vehicleId}`].isRequestOnlineCommand =
      payload.isRequestOnlineCommand
  },
  setInRequestOnlineCommand(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].isRequestOnlineCommand =
      payload.isRequestOnlineCommand
  },
  setInSrc(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].src = payload.src
  },

  setCamera(state, payload) {
    state.cameraProps[`video${payload.vehicleId}`] = payload.camera
  },

  setVideoFullscreenProp(state, payload) {
    state.isVideoFullscreenProps[payload.props] = payload.state
  },

  setOnLoadingState(state, payload) {
    state.isVideoProps[`video${payload.vehicleId}`].onLoadingTimeout = payload.state
  },
  setInOnLoadingState(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].onLoadingTimeout = payload.state
  },

  setGridNumber(state, payload) {
    state.gridNumber = payload
  },

  setPlaylist(state, payload) {
    const dataDemoTrackvision = JSON.parse(
      store.state.identity.featureFlag.find(
        (feature) => feature.key == 'vsms2_trackvision2_stream_demo_id'
      ).value
    )
    const isVideoDemo =
      process.env.VUE_APP_ENV === 'production' &&
      Object.keys(dataDemoTrackvision).includes(payload.vehicleId.toString())

    let tempPlaylist = [...state.playlist]

    const deviceType = Helper.methods.getDeviceType(payload.vehicle.device.deviceCode)

    const removeAll = tempPlaylist.filter((x) => x.vehicleId != payload.vehicleId)
    tempPlaylist = [...removeAll]

    const remain = payload.playlist.length + tempPlaylist.length - state.maxVideo
    if (remain) tempPlaylist.slice(remain)
    else tempPlaylist.slice(payload.playlist.length)

    const isHlsTesting = JSON.parse(
      store.state.identity.featureFlag.find((feature) => feature.key == 'is_hls_testing').value
    )

    const getStreamUrl = (type, imei, channel, flag, streamingEndpoint) => {
      let origin
      if (streamingEndpoint === 'trackvision_indo') {
        origin = process.env.VUE_APP_RTMP_URL_SERVER_INDO
      } else {
        origin = process.env.VUE_APP_RTMP_URL
      }

      if (type === 'bsj')
        return isHlsTesting
          ? `${process.env.VUE_APP_HLS_URL.replace(
              '{numFlag}',
              flag
            )}/live/stream/${imei}-${channel}.m3u8`
          : `${origin.replace('{numFlag}', flag)}/live/stream/${imei}-${channel}.flv`
      if (type === 'jc')
        return isHlsTesting
          ? `${process.env.VUE_APP_HLS_URL.replace('{numFlag}', flag)}/live/${channel}/${imei}.m3u8`
          : `${origin.replace('{numFlag}', flag)}/live/${channel}/${imei}.flv`
      if (type === 'flespi-howen') return null
    }

    const handleVideoDemo = () => {
      // handle video demo
      const isJc = payload.vehicle.device.deviceName.includes('JC')
      const cameraList = payload.playlist.map((data) =>
        isJc ? parseInt(data.split(':')[1]) + 1 : parseInt(data.split(':')[1])
      )

      const promises = []
      cameraList.forEach((camera) => {
        const filename = dataDemoTrackvision[payload.vehicleId][camera - 1]
        promises.push(
          client.query({
            query: GET_SIGNED_URL,
            variables: {
              filter: {
                filename,
                identifier: isJc ? 'jcDemo' : 'bsjDemo',
                vehicleId: payload.vehicleId,
              },
            },
            fetchPolicy: 'no-cache',
          })
        )
      })
      Promise.all(promises).then((response) => {
        payload.playlist.forEach((row, index) => {
          if (row != tempPlaylist[index]?.id) {
            const arr = row.split(':')
            const camera = payload.channel.findIndex((x) => x.value == row)
            tempPlaylist.push({
              id: row,
              vehicleId: arr[0],
              channel: arr[1],
              camera: camera + 1,
              licensePlate: payload.vehicle.licensePlate,
              calculatedMotionStatus: payload.calculatedMotionStatus,
              imei: payload.vehicle.imei,
              driver: payload.vehicle.driver1?.fullname,
              src: response[index].data.getSignedUrl.getSignedUrl.url,
              deviceType,
            })
          } else {
            tempPlaylist[index] = null
          }
        })
        state.playlist = [...tempPlaylist]
      })
      return
    }

    if (isVideoDemo) {
      return handleVideoDemo()
    }
    payload.playlist.forEach((row, index) => {
      if (row != tempPlaylist[index]?.id) {
        const arr = row.split(':')
        const camera = payload.channel.findIndex((x) => x.value == row)
        tempPlaylist.push({
          id: row,
          vehicleId: arr[0],
          channel: arr[1],
          camera: camera + 1,
          licensePlate: payload.vehicle.licensePlate,
          calculatedMotionStatus: payload.calculatedMotionStatus,
          imei: payload.vehicle.imei,
          deviceType,
          uid: payload.playlistWithUid.find((data) => data.playlist === row).uid,
        })
      } else {
        tempPlaylist[index] = null
      }
    })

    tempPlaylist = tempPlaylist.map((data, index) => {
      const arr = data.id.split(':')
      const domain = (index % 3) + 1
      const fleet = state.fleets.find((fleet) => fleet.vehicleId == data.vehicleId)
      const imei = fleet?.vehicle.imei
      const _isVideoDemo =
        process.env.VUE_APP_ENV === 'production' &&
        Object.keys(dataDemoTrackvision).includes(data.vehicleId)
      return {
        ...data,
        streamingEndpoint: payload.streamingEndpoint,
        src: _isVideoDemo
          ? data.src
          : getStreamUrl(deviceType, imei, arr[1], domain, payload.streamingEndpoint),
      }
    })

    state.playlist = [...tempPlaylist]
  },

  setPlaylistV2(state, payload) {
    const getChannelOrPlaylistList = (channel) => {
      return channel.filter((item) => item.value !== 'all')
    }
    const dataDemoTrackvision = JSON.parse(
      store.state.identity.featureFlag.find(
        (feature) => feature.key == 'vsms2_trackvision2_stream_demo_id'
      ).value
    )
    const isVideoDemo =
      process.env.VUE_APP_ENV === 'production' &&
      Object.keys(dataDemoTrackvision).includes(payload.vehicleId.toString())

    let tempPlaylist = [...state.playlist]

    const deviceType = Helper.methods.getDeviceType(payload.vehicle.device.deviceCode)
    const playlistWithoutVehicleIdSelected = tempPlaylist.filter(
      (x) => x.vehicleId != payload.vehicleId
    )
    tempPlaylist = [...playlistWithoutVehicleIdSelected]

    const isHlsTesting = JSON.parse(
      store.state.identity.featureFlag.find((feature) => feature.key == 'is_hls_testing').value
    )

    const getStreamUrl = (type, imei, channel, flag, streamingEndpoint) => {
      let origin
      if (streamingEndpoint === 'trackvision_indo') {
        origin = process.env.VUE_APP_RTMP_URL_SERVER_INDO
      } else {
        origin = process.env.VUE_APP_RTMP_URL
      }
      if (type === 'bsj')
        return isHlsTesting
          ? `${process.env.VUE_APP_HLS_URL.replace(
              '{numFlag}',
              flag
            )}/live/stream/${imei}-${channel}.m3u8`
          : `${origin.replace('{numFlag}', flag)}/live/stream/${imei}-${channel}.flv`
      if (type === 'jc')
        return isHlsTesting
          ? `${process.env.VUE_APP_HLS_URL.replace('{numFlag}', flag)}/live/${channel}/${imei}.m3u8`
          : `${origin.replace('{numFlag}', flag)}/live/${channel}/${imei}.flv`
      if (type === 'flespi-howen') return null
    }

    const handleVideoDemo = () => {
      // handle video demo
      const isJc = deviceType === 'jc'
      const cameraList = payload.playlist.map((data) =>
        isJc ? parseInt(data.split(':')[1]) + 1 : parseInt(data.split(':')[1])
      )

      const promises = []
      cameraList.forEach((camera) => {
        const filename = dataDemoTrackvision[payload.vehicleId][camera - 1]
        promises.push(
          client.query({
            query: GET_SIGNED_URL,
            variables: {
              filter: {
                filename,
                identifier: isJc ? 'jcDemo' : 'bsjDemo',
                vehicleId: payload.vehicleId,
              },
            },
            fetchPolicy: 'no-cache',
          })
        )
      })
      Promise.all(promises).then((response) => {
        payload.playlist.forEach((row, index) => {
          if (row != tempPlaylist[index]?.id) {
            const arr = row.split(':')
            const camera = getChannelOrPlaylistList(payload.channel).findIndex(
              (x) => x.value == row
            )
            tempPlaylist.push({
              id: row,
              vehicleId: arr[0],
              channel: arr[1],
              camera: camera + 1,
              licensePlate: payload.vehicle.licensePlate,
              calculatedMotionStatus: payload.calculatedMotionStatus,
              src: response[index].data.getSignedUrl.getSignedUrl.url,
              imei: payload.vehicle.imei,
              driver: payload.vehicle.driver1?.fullname,
              deviceType,
            })
          } else {
            tempPlaylist[index] = null
          }
        })
        state.playlist = [...tempPlaylist]
      })
      return
    }

    if (isVideoDemo) {
      return handleVideoDemo()
    }

    payload.playlist.forEach((row, index) => {
      if (row != tempPlaylist[index]?.id) {
        const arr = row.split(':')
        const camera = getChannelOrPlaylistList(payload.channel).findIndex((x) => x.value == row)
        tempPlaylist.push({
          id: row,
          vehicleId: arr[0],
          channel: arr[1],
          camera: camera + 1,
          licensePlate: payload.vehicle.licensePlate,
          calculatedMotionStatus: payload.calculatedMotionStatus,
          imei: payload.vehicle.imei,
          driver: payload.vehicle.driver1?.fullname,
          deviceType,
          uid: payload.playlistWithUid.find((data) => data.playlist === row).uid,
        })
      } else {
        tempPlaylist[index] = null
      }
    })

    tempPlaylist = tempPlaylist.map((data, index) => {
      const arr = data.id.split(':')
      const domain = (index % 3) + 1
      const fleet = state.fleets.find((fleet) => fleet.vehicleId == data.vehicleId)
      const imei = fleet?.vehicle.imei
      const _isVideoDemo =
        process.env.VUE_APP_ENV === 'production' &&
        Object.keys(dataDemoTrackvision).includes(data.vehicleId)
      return {
        ...data,
        streamingEndpoint: payload.streamingEndpoint,
        src: _isVideoDemo
          ? data.src
          : getStreamUrl(deviceType, imei, arr[1], domain, payload.streamingEndpoint),
      }
    })

    state.playlist = [...tempPlaylist]
  },

  resetPlaylist(state) {
    state.playlist = []
  },

  removePlaylist(state, id) {
    state.playlist = state.playlist.filter((data) => data.id !== id)
  },

  setFleetListDisplay(state, payload) {
    state.fleetListDisplay = payload
  },

  setLastClosedPlaylist(state, payload) {
    state.lastClosedPlaylist = payload
  },

  setWorkerTrackvision(state, payload) {
    state.workerTrackvision = payload
  },

  setRecordIdActive(state, payload) {
    state.recordIdActive = payload
  },

  resetRecordIdActive(state) {
    state.recordIdActive = null
  },

  setVehicleTypeList(state, payload) {
    state.vehicleTypeList = payload
  },

  setVgroupsList(state, payload) {
    state.vgroupsList = payload
  },

  /**
   *
   * @param {string} playlistId format `{vehicleId}:{channel}`
   * @param {string} url url for flespi howen
   */
  addMapFlespiHowenState(state, { playlistId, url }) {
    state.mapFlespiHowenState = [...state.mapFlespiHowenState, { playlistId, url }]
  },
}
